module.exports = __webpack_public_path__ + "static/media/AepsBankit.ea8d7847.png";